import * as fp from 'lodash/fp';
import { CampaignCondition, CampaignType } from '~/types/coupon';

const getDiscountFn = fp.cond<
  { type: CampaignType; condition: CampaignCondition },
  (total: number) => number
>([
  [
    fp.where({ type: fp.eq(CampaignType.DISCOUNT), condition: fp.T }),
    ({ condition }) => {
      const couponRules = fp.extend({
        costLimit: Infinity,
        discount: 0,
      })(condition[CampaignType.DISCOUNT] || {});

      return (total: number) => {
        return fp.gte(total, couponRules.costLimit) ? Math.min(total, couponRules.discount) : 0;
      };
    },
  ],
  [
    fp.where({ type: fp.eq(CampaignType.DISCOUNT_PERCENTAGE), condition: fp.T }),
    ({ condition }) => {
      const couponRules = fp.extend({
        costLimit: Infinity,
        percentage: 0,
        discountLimit: 0,
      })(condition[CampaignType.DISCOUNT_PERCENTAGE] || {});

      return (total: number) => {
        return fp.gte(total, couponRules.costLimit)
          ? Math.floor(Math.min(total * couponRules.percentage, couponRules.discountLimit))
          : 0;
      };
    },
  ],
  [
    fp.where({ type: fp.eq(CampaignType.ITEM), condition: fp.T }),
    () => {
      return (total: number) => {
        return 0;
      };
    },
  ],
]);

export default getDiscountFn;
